import { render, staticRenderFns } from "./cghdfirst.vue?vue&type=template&id=5794171f&scoped=true&"
import script from "./cghdfirst.vue?vue&type=script&lang=js&"
export * from "./cghdfirst.vue?vue&type=script&lang=js&"
import style0 from "./cghdfirst.vue?vue&type=style&index=0&id=5794171f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794171f",
  null
  
)

export default component.exports